var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCargoDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1667 17.4444V6.55556C21.6267 6.55556 22 6.20711 22 5.77778C22 5.34844 21.6267 5 21.1667 5H2.83333C2.37333 5 2 5.34844 2 5.77778C2 6.20711 2.37333 6.55556 2.83333 6.55556V17.4444C2.37333 17.4444 2 17.7929 2 18.2222C2 18.6516 2.37333 19 2.83333 19H21.1667C21.6267 19 22 18.6516 22 18.2222C22 17.7929 21.6267 17.4444 21.1667 17.4444ZM8.66667 15.1111C8.66667 15.5404 8.29333 15.8889 7.83333 15.8889C7.37333 15.8889 7 15.5404 7 15.1111V8.88889C7 8.45956 7.37333 8.11111 7.83333 8.11111C8.29333 8.11111 8.66667 8.45956 8.66667 8.88889V15.1111ZM12.8333 15.1111C12.8333 15.5404 12.46 15.8889 12 15.8889C11.54 15.8889 11.1667 15.5404 11.1667 15.1111V8.88889C11.1667 8.45956 11.54 8.11111 12 8.11111C12.46 8.11111 12.8333 8.45956 12.8333 8.88889V15.1111ZM17 15.1111C17 15.5404 16.6267 15.8889 16.1667 15.8889C15.7067 15.8889 15.3333 15.5404 15.3333 15.1111V8.88889C15.3333 8.45956 15.7067 8.11111 16.1667 8.11111C16.6267 8.11111 17 8.45956 17 8.88889V15.1111Z",
    fill: "#1D4650"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargoDetails);
export default __webpack_public_path__ + "static/media/cargo-details.a793aefe2f8a06b8fbe4979f3309f34a.svg";
export { ForwardRef as ReactComponent };